<template>
  <div class="takt-journal">
    <div class="takt-journal-list">
      <slot
        name="list"
        :takt_journal="takt_journal"
        :week_days="week_days"
        />
    </div>
    <div
      id="takt-journal-content"
      ref="takt-journal-content"
      class="takt-journal-content"
      >
      <slot
        name="content"
        :takt_journal="takt_journal"
        :week_days="week_days"
        :project="project"
        />
    </div>
    <div class="takt-journal-settings">
      <slot
        name="settings"
        :settings="settings"
        :takt_times="takt_times"
        />
    </div>
  </div>
</template>
<script>
  export default {
    props: ['takt_journal', 'week_days', 'project', 'takt_times', 'settings']
  }
</script>
<style>
  .takt-journal {
    position: absolute;
    height: 100%;
    display: flex;
    background-color: #121212;
    z-index: 20;
    color: white;
    overflow: hidden !important;
  }
  .takt-journal-list {
    height: 100%;
    width: 200px;
    overflow: auto;
  }
  .takt-journal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: calc(100vw - 520px);
    margin: 0px 10px 0px 10px;
    overflow: auto;
  }
  .takt-journal-settings {
    width: 320px;
  }
</style>
